function jdn(y, m, d) {
  const a = Math.floor((14 - m) / 12);
  const yy = y + 4800 - a;
  const mm = m + 12 * a - 3;
  return d + Math.floor((153 * mm + 2) / 5) + 365 * yy + Math.floor(yy / 4) - Math.floor(yy / 100) + Math.floor(yy / 400) - 32045;
}

export function gregToEth(gy, gm, gd) {
  const ethEpoch = 1724221;
  const daysSinceEpoch = jdn(gy, gm, gd) - ethEpoch;
  const cycle = Math.floor(daysSinceEpoch / 1461);
  let daysInCycle = daysSinceEpoch % 1461;
  let ey, edoy;
  if (daysInCycle < 365) {
    ey = cycle * 4 + 1; edoy = daysInCycle + 1;
  } else if (daysInCycle < 730) {
    ey = cycle * 4 + 2; edoy = daysInCycle - 365 + 1;
  } else if (daysInCycle < 1095) {
    ey = cycle * 4 + 3; edoy = daysInCycle - 730 + 1;
  } else {
    ey = cycle * 4 + 4; edoy = daysInCycle - 1095 + 1;
  }
  let em, ed;
  if (edoy <= 360) {
    em = Math.ceil(edoy / 30);
    ed = edoy - (em - 1) * 30;
  } else {
    em = 13;
    ed = edoy - 360;
  }
  return { year: ey, month: em, day: ed };
}

export function toEthiopianDateStr(date) {
  const e = gregToEth(date.getFullYear(), date.getMonth() + 1, date.getDate());
  return `${String(e.day).padStart(2, '0')}/${String(e.month).padStart(2, '0')}/${String(e.year).padStart(4, '0')}`;
}

function ethJDN(ey, em, ed) {
  const ethEpoch = 1724221;
  return ethEpoch + 365 * (ey - 1) + Math.floor((ey - 1) / 4) + 30 * (em - 1) + (ed - 1);
}

function jdnToGreg(jdn) {
  const a = jdn + 32044;
  const b = Math.floor((4 * a + 3) / 146097);
  const c = a - Math.floor((146097 * b) / 4);
  const d = Math.floor((4 * c + 3) / 1461);
  const e = c - Math.floor((1461 * d) / 4);
  const m = Math.floor((5 * e + 2) / 153);
  const day = e - Math.floor((153 * m + 2) / 5) + 1;
  const month = m + 3 - 12 * Math.floor(m / 10);
  const year = 100 * b + d - 4800 + Math.floor(m / 10);
  return { year, month, day };
}

export function ethToGreg(ey, em, ed) {
  const jdn = ethJDN(ey, em, ed);
  return jdnToGreg(jdn);
}

export function ethDateStrToGregStr(ethDateStr) {
  if (!ethDateStr || typeof ethDateStr !== 'string') return ethDateStr;
  const parts = ethDateStr.split('/');
  if (parts.length !== 3) return ethDateStr;
  const d = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const y = parseInt(parts[2], 10);
  if (isNaN(d) || isNaN(m) || isNaN(y)) return ethDateStr;
  const greg = ethToGreg(y, m, d);
  if (!greg) return ethDateStr;
  return `${String(greg.year).padStart(4, '0')}-${String(greg.month).padStart(2, '0')}-${String(greg.day).padStart(2, '0')}`;
}

export function gregDateStrToEthStr(gregDateStr) {
  if (!gregDateStr || typeof gregDateStr !== 'string') return gregDateStr;
  const parts = gregDateStr.split('T')[0].split('-');
  if (parts.length !== 3) return gregDateStr;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const d = parseInt(parts[2], 10);
  if (isNaN(y) || isNaN(m) || isNaN(d)) return gregDateStr;
  const eth = gregToEth(y, m, d);
  if (!eth) return gregDateStr;
  return `${String(eth.day).padStart(2, '0')}/${String(eth.month).padStart(2, '0')}/${String(eth.year).padStart(4, '0')}`;
}

export function convertDbDateToDisplay(dbDate) {
  if (!dbDate) return toEthiopianDateStr(new Date());
  return gregDateStrToEthStr(dbDate);
}

export function formatEthDate(date) {
  const e = gregToEth(date.getFullYear(), date.getMonth() + 1, date.getDate());
  const months = ['መስከረም', 'ጥቅምት', 'ኅዳር', 'ታኅሣሥ', 'ጥር', 'የካቲት', 'መጋቢት', 'ሚያዝያ', 'ግንቦት', 'ሰኔ', 'ሐምሌ', 'ነሐሴ', 'ጳጉሜ'];
  return `${months[e.month - 1]} ${e.day}, ${e.year}`;
}

export function formatEthDateEn(date) {
  const e = gregToEth(date.getFullYear(), date.getMonth() + 1, date.getDate());
  const months = ['Meskerem', 'Tikimt', 'Hidar', 'Tahsas', 'Ter', 'Yekatit', 'Magabit', 'Miazia', 'Ginbot', 'Sene', 'Hamle', 'Nehase', 'Pagume'];
  return `${months[e.month - 1]} ${e.day}, ${e.year}`;
}
